module.exports = __webpack_public_path__ + "img/create-booking.ec15be83.svg";